module.exports = __webpack_public_path__ + "img/pantalla 7-1 mobile.34dcf275.svg";